import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";
import { idParam } from "../helpers/commons.helpers";
import reservationRouter from "../views/Reservations/router/reservation.router";
import rateRouters from "../views/rates/router/rate.routers";

const routes = [
  {
    path: "/",
    redirect: "/signin",
    name: "Home",
    meta: {
      title: "Home",
      requiresAuth: false,
      roles: []
    }
  },
  {
    path: "/signin",
    name: "Login",
    meta: {
      title: "Login",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(/* webpackChunkName: "signin" */ "@/views/Pages/SignIn")
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: {
      title: "Forgot Password",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "forgotPassword" */ "@/views/Pages/ForgotPassword"
      )
  },
  {
    path: "/recover-password",
    name: "RecoverPassword",
    meta: {
      title: "Recover Password",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "recoverPassword" */ "@/views/Pages/RecoverPassword"
      )
  },
  {
    path: "/:resourceType/:id/generate-pdf",
    name: "Download",
    meta: {
      title: "Download",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "downloadFile" */ "@/views/GeneralViews/DownloadPDF.vue"
      )
  },
  {
    path: "/quotes/:id/accept",
    name: "AcceptQuote",
    meta: {
      title: "Quote Accepted",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(/* webpackChunkName: "reservationConfirm" */ "@/views/Pages/quotes/AcceptQuote.vue")
  },
  {
    path: "/quotes/:id/reject",
    name: "RejectQuote",
    meta: {
      title: "Quote Rejected",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(/* webpackChunkName: "reservationReject" */ "@/views/Pages/quotes/RejectQuote.vue")
  },
  {
    path: "/reservation-confirmed-operator/:id",
    name: "ReservationConfirmedSupplier",
    meta: {
      title: "Reservation Confirmed",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "reservationConfirm" */ "@/views/Pages/reservations/AcceptReservation.vue"
      )
  },

  {
    path: "/reservation-reject-operator/:supplier_id/:id",
    name: "ReservationCancelSupplier",
    meta: {
      title: "Reservation Rejected",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "reservationReject" */ "@/views/Pages/reservations/RejectReservation.vue"
      )
  },
  {
    path: "/reservations/:reservationId/suppliers/:supplierId/assign-driver",
    name: "AssignDriverToTrip",
    meta: {
      title: "Assign Driver to Trip",
      requiresAuth: false,
      roles: []
    },
    component: () =>
      import(
        /* webpackChunkName: "driversAssign" */ "@/views/Pages/AssignDriverToTrip"
      )
  },
  {
    path: "/validate/oauth",
    name: "Auth2",
    meta: {
      title: "Auth2",
      requiresAuth: true,
      roles: ["supplier", "supplier_access", "dispatch"]
    },
    component: () =>
      import(
        /* webpackChunkName: "authValidation" */ "@/views/Settings/Views/AuthValidation"
      )
  },

  {
    path: "/",
    component: DashboardLayout,
    redirect: "/reservations",
    name: "Reservations",
    meta: {
      title: "Reservations",
      requiresAuth: true,
      roles: ["supplier", "supplier_access", "dispatch"]
    },
    children: [
      ...reservationRouter,
      {
        path: "/customers",
        name: "Customers",
        meta: {
          title: "Customers",
          modules: ["customers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },

        component: () =>
          import(
            /* webpackChunkName: "customers" */ "@/views/Customers/Views/Customers"
          )
      },
      {
        path: "/customers/new",
        name: "NewCustomer",
        component: () =>
          import(
            /* webpackChunkName: "Newcustomer" */ "@/views/Customers/Views/NewCustomer"
          ),
        meta: {
          title: "New Customer",
          modules: ["customers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        }
      },
      {
        path: `/customers/${idParam()}`,
        name: "CustomerProfile",
        meta: {
          title: "Customer Profile",
          modules: ["customers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "CustomerProfile" */ "@/views/Customers/Views/CustomerProfile"
          )
      },

      {
        path: "/destinations",
        name: "Destinations",
        meta: {
          title: "Destinations",
          modules: ["destinations"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "destinations" */ "@/views/Destinations/Views/Destinations"
          )
      },

      {
        path: "/destinations/:id/rates",
        name: "DestinationRates",
        meta: {
          title: "Destination Rates",
          modules: ["destinations"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "DestinationsRates" */ "@/views/rates/pages/DestinationOfRates"
          )
      },
      ...rateRouters,
      {
        path: "/coverage-areas",
        name: "CoverageAreas",
        meta: {
          title: "Coverage Areas",
          modules: ["areas"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "areas" */ "@/views/CoverageArea/Views/CoverageAreas"
          )
      },
      {
        path: "/destinations/:id/coverage-areas",
        name: "CoverageAreasOfDestination",
        meta: {
          title: "Coverage Areas of Destination",
          modules: ["destinations"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "areasDestination" */ "@/views/CoverageArea/Views/DestinationOfCoverage"
          )
      },
      {
        path: "/coverage-areas/new",
        name: "NewCoverageArea",
        meta: {
          title: "New Coverage Area",
          modules: ["areas"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "newArea" */ "@/views/CoverageArea/Views/NewCoverageAreas"
          )
      },
      {
        path: `/coverage-areas/${idParam()}`,
        name: "AreaDetails",
        meta: {
          title: "Area Details",
          modules: ["areas"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "area" */ "@/views/CoverageArea/Views/AreaDetails"
          )
      },
      {
        path: "/my-profile",
        name: "MyProfile",
        meta: {
          title: "My Profile",
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "myProfile" */ "@/views/Pages/UserProfile/UserProfile"
          )
      },
      {
        path: "/vehicles",
        name: "Vehicles",
        meta: {
          title: "Vehicles",
          modules: ["vehicles"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "vehicles" */ "@/views/Vehicles/Views/Vehicles"
          )
      },
      {
        path: "/vehicles/new",
        name: "NewVehicle",
        meta: {
          title: "New Vehicle",
          modules: ["vehicles"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "newVehicle" */ "@/views/Vehicles/Views/NewVehicle"
          )
      },
      {
        path: `/vehicles/${idParam()}`,
        name: "VehicleDetails",
        meta: {
          title: "Vehicle Details",
          modules: ["vehicles"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "VehicleDetails" */ "@/views/Vehicles/Views/VehicleDetails"
          )
      },
      {
        path: "/drivers",
        name: "Drivers",
        meta: {
          title: "Drivers",
          modules: ["drivers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "drivers" */ "@/views/Drivers/Views/Drivers"
          )
      },
      {
        path: "/drivers/new",
        name: "NewDriver",
        meta: {
          title: "New Driver",
          modules: ["drivers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "drivers" */ "@/views/Drivers/Views/NewDriver"
          )
      },
      {
        path: `/drivers/${idParam()}`,
        name: "Driver profile",
        meta: {
          title: "Driver Profile",
          modules: ["drivers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "driverProfile" */ "@/views/Drivers/Views/DriverProfile"
          )
      },
      {
        path: "/drivers/:id/schedules",
        name: "DriverSchedule",
        meta: {
          title: "Driver Schedule",
          modules: ["drivers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "DriverSchedule" */ "@/views/Drivers/Views/ScheduleOfDriver"
          )
      },

      {
        path: "/schedules",
        name: "DriversSchedule",
        meta: {
          title: "Drivers Schedule",
          modules: ["drivers"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "driverSchedules" */ "@/views/Drivers/Views/Schedule"
          )
      },
      {
        path: "/users",
        name: "Users",
        meta: {
          title: "Users",
          modules: ["users"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(/* webpackChunkName: "users" */ "@/views/Users/Views/Users")
      },
      {
        path: "/users/new",
        name: "NewUser",
        meta: {
          title: "New User",
          modules: ["users"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "newUsers" */ "@/views/Users/Views/NewUser"
          )
      },
      {
        path: `/users/${idParam()}`,
        name: "UserProfile",
        meta: {
          title: "User Profile",
          modules: ["users"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "userProfile" */ "@/views/Users/Views/userProfile"
          )
      },
      {
        path: "/settings",
        name: "Settings",
        meta: {
          title: "Settings",
          modules: ["settings"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "settings" */ "@/views/Settings/Views/Settings"
          )
      },
      {
        path: "/help",
        name: "Help",
        meta: {
          title: "Help",
          modules: ["help"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(/* webpackChunkName: "help" */ "@/views/Tools/Help/Help")
      },
      {
        path: "/help/:moduleSlug",
        name: "HelpResults",
        meta: {
          title: "Help Results",
          modules: ["help"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "helpResults" */ "@/views/Tools/Help/HelpResults"
          )
      },
      {
        path: "/help/:moduleSlug/:documentSlug",
        name: "HelpDetails",
        meta: {
          title: "Help Details",
          modules: ["help"],
          requiresAuth: true,
          roles: ["supplier", "supplier_access", "dispatch"]
        },
        component: () =>
          import(
            /* webpackChunkName: "helpDetails" */ "@/views/Tools/Help/HelpDetails"
          )
      },

    ]
  },
  {
    path: "*",
    component: NotFound
  }
];

export default routes;
